import { render, staticRenderFns } from "./dealer-list.vue?vue&type=template&id=3a479172"
import script from "./dealer-list.vue?vue&type=script&lang=ts"
export * from "./dealer-list.vue?vue&type=script&lang=ts"
import style0 from "./dealer-list.vue?vue&type=style&index=0&id=3a479172&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports